import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ColorAnimation } from "./ColorAnimation";
export var HslAnimation = /*#__PURE__*/function () {
  function HslAnimation() {
    _classCallCheck(this, HslAnimation);

    this.h = new ColorAnimation();
    this.s = new ColorAnimation();
    this.l = new ColorAnimation();
  }

  _createClass(HslAnimation, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.h.load(data.h);
      this.s.load(data.s);
      this.l.load(data.l);
    }
  }]);

  return HslAnimation;
}();